import moment from 'moment';

export default {
  name: 'timeline',
  props: {
    list: {
      type: Array,
      required: true,
    },

    direction: {
      type: String,
      default: 'future',
    },

    dateRange: {
      type: Array,
      required: false,
    },

    create: {
      type: Function,
      required: true,
    },

    edit: {
      type: Function,
      required: false,
    },
  },

  computed: {
    points() {
      const points = [];
      let daysAhead = 14;

      const start = this.dateRange.length && moment(this.dateRange[0]).isValid() ?
      moment(this.dateRange[0]) : moment();
      start.startOf('day');

      if (this.dateRange.length && moment(this.dateRange[1]).isValid()) {
        daysAhead = moment(this.dateRange[1]).startOf('day')
        .diff(start, 'days') + 1;
      } else if (this.list.length) {
        const diff = moment(this.list[this.list.length - 1].start, 'DD/MM/YYYY HH:mm')
        .diff(start, 'days');
        daysAhead = diff > daysAhead ? diff + 1 : daysAhead;
      }

      for (let i = 0; i < daysAhead; i += 1) {
        const date = moment(start);
        if (this.direction === 'future') {
          date.add(i, 'days');
        } else {
          date.subtract(i, 'days');
        }

        points.push({
          date,
          day: date.format('DD'),
          month: date.format('MMMM'),
          year: date.format('YYYY'),
        });
      }

      return points;
    },
  },

  methods: {
    isWeekend(date) {
      return date.format('dddd') === 'Saturday' || date.format('dddd') === 'Sunday';
    },

    getDayOrders(date) {
      date = date.startOf('day');
      return this.list.filter(o => moment(o.start, 'DD/MM/YYYY HH:mm')
      .startOf('day').diff(date, 'day') === 0);
    },

    onEdit(date) {
      if (!this.edit) return false;

      return (o) => {
        this.edit(date, o);
      };
    },
  },

  components: {
    VAppointmentCard: require('./../appointmentCard/appointmentCard.vue'),
  },
};



// WEBPACK FOOTER //
// ./src/app/components/timeline/timeline.js